export const PayablesEnum = {
  lookupTypeId: 1202,
};
